import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../config/reduxIndex';
import PageWrapper from '../../shared/PageWrapper';
import PMTGSContainer from '../../../containers/projectmanager/PMTGSContainer';
import PMHomeContainer from '../../../containers/projectmanager/PMHomeContainer';
import PMBPContainer from '../../../containers/projectmanager/PMBPContainer';
import PMProjectContainer from '../../../containers/projectmanager/PMProjectContainer';
import PMPhaseContainer from '../../../containers/projectmanager/PMPhaseContainer';

class PMRoot extends Component {
	state = {
		mode: "home"
	}

	componentWillMount = () => {
		this.props.setDefault();
	}

	componentDidMount = () => {
		this.props.getData();
	}

	render() {
		const p = this.props;
		const { match } = p;
		const loading = p.reduxData.loading;

		return (
			<PageWrapper match={match}>
				{!loading ? this.switch() : null}
			</PageWrapper>
		);
	}

	switch = () => {
		const { mode } = this.state;
		const p = this.props;

		switch (mode) {
			case 'home':
				return <PMHomeContainer
					selectBP={this.selectBP}
					selectBPFromSearch={this.selectBPFromSearch}
					selectProjectFromSearch={this.selectProjectFromSearch}
				/>
			case 'bp':
				return <PMBPContainer
					changeMode={this.changeMode}
					selectProject={this.selectProject}
				/>
			case 'project':
				return <PMProjectContainer
					changeMode={this.changeMode}
					selectPhase={this.selectPhase}
				/>
			case 'phase':
				return <PMPhaseContainer
					changeMode={this.changeMode}
					selectTG={this.selectTG}
				/>
			case 'tasks':
				return <PMTGSContainer
					changeMode={this.changeMode}
				/>
		}
	}

	selectBP = (id) => {
		const p = this.props;
		let loc = p.reduxData.storedBPs.findIndex(indexOfBP)

		this.setState({
			mode: 'bp'
		})
		this.props.setAttributeByObj({
			currentBP: p.reduxData.storedBPs[loc]
		});

		function indexOfBP(bp) {
			return bp.uniqueID === id;
		}
	}

	selectBPFromSearch = (obj) => {
		const p = this.props;
		let loc = p.reduxData.storedBPs.findIndex(indexOfBP)

		this.setState({
			mode: 'bp'
		})
		this.props.setAttributeByObj({
			currentBP: p.reduxData.storedBPs[loc]
		});

		function indexOfBP(bp) {
			return bp.uniqueID === obj.cardCode;
		}
	}

	selectProject = (id) => {
		const p = this.props;
		let loc = p.reduxData.storedProjects.findIndex(indexOfProject)
		this.setState({
			mode: 'project'
		})

		this.props.setAttributeByObj({
			currentProj: loc
		});

		function indexOfProject(pj) {
			return pj.uniqueID === id;
		}
	}

	selectProjectFromSearch = (obj) => {
		const p = this.props;
		let loc = p.reduxData.storedProjects.findIndex(indexOfProject);
		let loc_bp = p.reduxData.storedBPs.findIndex(indexOfBP);

		if (loc > -1) {
			this.setState({
				mode: 'project'
			})
			this.props.setAttributeByObj({
				currentProj: loc,
				currentBP: p.reduxData.storedBPs[loc_bp]
			});
		}

		function indexOfProject(pj) {
			return pj.uniqueID === obj.uniqueID;
		}
		function indexOfBP(bp) {
			return bp.uniqueID === obj.parentID;
		}
	}

	selectPhase = (id) => {
		const p = this.props;
		let loc = p.reduxData.storedPhases.findIndex(indexOfPhase)
		this.setState({
			mode: 'phase'
		})

		this.props.setAttributeByObj({
			currentPhase: loc
		});

		function indexOfPhase(pj) {
			return pj.uniqueID === id;
		}
	}

	selectTG = (id) => {
		const p = this.props;
		let loc = p.reduxData.storedTaskGroups.findIndex(indexOfTG)
		this.setState({
			mode: 'tasks'
		})

		this.props.setAttributeByObj({
			currentTaskGroup: loc
		});

		function indexOfTG(pj) {
			return pj.uniqueID === id;
		}
	}

	changeMode = (mode, e) => {
		this.setState({
			mode: mode
		})

		if (e !== null) (
			this.props.setAttributeByObj({
				currentBP: e
			})
		)
	}

}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		setDefault: () => {
			dispatch(actions.pm.setDefault());
		},
		getData: () => {
			dispatch(actions.pm.getData());
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMRoot);


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMRoot.js